define(
  'app/views/register_form_view',[
    'app/setup', 'app/models/registration',
    'app/models/organizational_registeration', 'app/views/helper',
    'app/views/city_selector_view',
  ],
  function(
    takhfifan, registration,
    organizational_registeration, helper, citySelectorView
  ) {

  takhfifan.RegisterFormView = Backbone.View.extend({

    events: {
      'click .tkh-register-back': 'triggerRegisterFormBack',
      'submit form': 'register'
    },

    initialize: function() {
      var _this = this;

      takhfifan.eventHub.on('customer:login', function() {
        //_this.$el.hide();
      }, this);

      takhfifan.eventHub.on('customer:registerForm', function() {
        _this.$el.show();
      }, this);

      takhfifan.eventHub.on('formkey', function(formKey) {
        _this.model.set('formKey', formKey);
      }, this);

      takhfifan.eventHub.on(
        'customer:registrationError',
        function(errors) {
          this.renderErrors(errors);
          _this.enableForm();
        }, this);

      takhfifan.eventHub.on('navigation:setCity', function(city) {
        _this.setCity(city);
      }, this);

      this.model.set('submitUrl', this.$el.data('url'));

      // if(this.$el.find('#telephone').attr('type') == 'hidden'){
      //   this.model.set('phoneNumberRequirement', 'optional');
      // }
      // else{
      //   this.model.set('phoneNumberRequirement', 'required');
      // }

      Backbone.Validation.bind(this);
      this._buttonContents = this.$(':submit').first().html();
      this.$el.find('.inline-form input[required]').on('change invalid', function() {
        var textfield = $(this).get(0);

        textfield.setCustomValidity('');

        if (!textfield.validity.valid) {
          var $name = $(this).attr('name');
          if($name === 'fullname'){
            textfield.setCustomValidity('لطفا نام و نام‌خانوادگی خود را وارد کنید');
          }else if ($name === 'email'){
            textfield.setCustomValidity('لطفا آدرس ایمیل خود را وارد کنید');
          }else if ($name === 'password'){
            textfield.setCustomValidity('لطفا رمز عبوری بین ۶ تا ۵۰ کاراکتر وارد نمایید');
          }else{
            textfield.setCustomValidity('لطفا مقدار معتبر در این فیلد وارد کنید.');
          }
        }
      });
    },

    triggerRegisterFormBack: function(event) {
      event.preventDefault();
      this.$el.hide();
      takhfifan.eventHub.trigger('customer:registerFormBack');
    },

    setCity: function(city) {
      var $dropdown = this.$el.find('#city');
      $dropdown.find('option').removeProp('selected');
      $dropdown.find(
        'option[value="' + city.id + '"]'
      ).prop('selected', true);
    },

    register: function(e) {
      this.disableForm();
      this.clearMessages();
      e.preventDefault();
      //var telephone = takhfifan.Helper.formatPhone(this.$('#telephone').val());

      var data = takhfifan.Helper.serializeToObject(this);

      // needed for validation of suburb and area fields, which depend on parents
      data['need_suburb'] = this.$('.tkh-suburbs ul').children().length > 0;
      data['need_area'] = this.$('.tkh-areas ul').children().length > 0;
      data['accepted_privacy_policy'] = this.$('#accepted_privacy_policy').prop('checked');

      if (this.model.set(data, { validate: true })) {
        this.model.register();
        if(this.$el.parent().hasClass('tkh-guest-register-form')){
          takhfifan.eventHub.trigger('ga:checkoutOption', {
            "step": 2,
            "option": "new user"
          });
        }
        return true;
      } else {
        this.$('.alert-error').slideDown();
        this.enableForm();
      }
    },

    disableForm: function() {
      this.$(':submit').prop('disabled',true);
      this.$(':submit').empty().append('<div class="btn-text"><span class="spinner"></span></div>');
    },

    enableForm: function() {
      this.$(':submit').prop('disabled',false);
      this.$(':submit').empty().append(this._buttonContents);
    },

    renderErrors: function(errors) {
      this.$('.success').empty().hide();
      var $errors = this.$('.alert-error');
      $errors.empty();
      _.each(errors, function(e) {
        var preFormattedError='<div class="alert alert-red"><span class="icon-info"></span><p>'+
          e + '</p></div>';
        var $li = $('<li></li>');
        $li.html(preFormattedError);
        $errors.append($li);
      });
      $errors.show();
    },

    clearMessages: function() {
      this.$('.alert-error').empty();
    },

  });

  var registration = new takhfifan.Registration();
  var organizationalRegisteration = new takhfifan.OrganizationalRegistration();

  $('.tkh-register-form').each(function(){
    new takhfifan.RegisterFormView({ el: $(this), model: registration });
  });
  $('.tkh-register-form-organizational').each(function(){
    new takhfifan.RegisterFormView({ el: $(this), model: organizationalRegisteration });
  });

});

